/* eslint-disable no-useless-computed-key */
import t from '../../../labels/labelling-utils';

import { ITournament, TennisCalendarStatus } from './tennis-calendar';

export const base = 'Tutti i tornei';
export const filterCriterion = 'tournamentType';

export const tournamentTypeMap: { [key: string]: { label: string; customName: string } } = {
  ['WTA500']: { label: 'WTA 500', customName: 'WTA 500' },
  ['WTA250']: { label: 'WTA 250', customName: 'WTA 250' },
  ['ATP250']: { label: 'ATP 250', customName: 'ATP 250' },
  ['GrandSlam']: { label: 'Grandi Slam', customName: 'GrandSlam' },
  ['WTA1000']: { label: 'WTA 1000', customName: 'WTA 1000' },
  ['ATP500']: { label: 'ATP 500', customName: 'WTA 500' },
  ['Masters']: { label: 'ATP 1000', customName: 'ATP Masters 1000' },
};

export const tournamentsStatusMap: { status: TennisCalendarStatus; label: string; courtesyMsg: string }[] = [
  { status: 'FINISHED', label: 'Tornei conclusi', courtesyMsg: t('tennis.calendar.courtesymsg.completed') },
  { status: 'LIVE', label: 'Tornei in corso', courtesyMsg: t('tennis.calendar.courtesymsg.ongoing') },
  { status: 'UPCOMING', label: 'Tornei in programma', courtesyMsg: t('tennis.calendar.courtesymsg.scheduled') },
];

export const getCourtesyMsg = (filter: string | null, defaultFilter: string, base: string) => {
  return filter || defaultFilter !== base
    ? `Non ci sono ${(filter || defaultFilter) === 'GrandSlam' ? '' : 'tornei'} ${
        (filter || defaultFilter) === 'Masters'
          ? tournamentTypeMap.Masters.customName
          : tournamentTypeMap[filter || defaultFilter].label
      } in questa sezione`
    : null;
};

export const handleScroll = (wrapperRef: React.RefObject<HTMLDivElement>, status: string) => {
  const active = wrapperRef.current?.querySelector(`#${status}`);
  active?.scrollIntoView({ behavior: 'smooth' });
};

export const hasOngoing = (array: ITournament[]) => array.some((tournament) => tournament.status === 'LIVE');
export const hasScheduled = (array: ITournament[]) => array.some((tournament) => tournament.status === 'UPCOMING');
